import React from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

const BenefitsList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link to={`/mis/teacherBenefits/${e.id}/faculties`}>{e.name}</Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "نام(فارسی)" , content: (e) => renderLink(e) },
    { path: "name_en", label: "نام(انگلیسی)" },
    { path: "benefit", label: "امتیاز" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default BenefitsList;
